import React from 'react'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useEvent } from '@emerald-works/react-event-bus-client'
import { useExternalApp } from '../../../../../hooks'
import { Box, Typography, useMediaQuery } from '@mui/material'
import { ActionButton } from '../../../../action-buttons'
import { CrownIcon } from '../../icons'
import { contentSlice, b2cSignupSlice } from '../../../../../reducers'
import { formatAmount } from '../../../../../pages/b2c-signup/components/utils'
import { useStyles } from './style'

const PaywallCTA = () => {
  const isMobile = useMediaQuery('(max-width:967px)')
  const classes = useStyles()
  const { getMtUrl } = useExternalApp()

  const contentConsumed = useSelector(contentSlice.selectors.selectMeteringUsed)
  const meteringLimit = useSelector(contentSlice.selectors.selectMeteringLimit)

  const plan = useSelector(b2cSignupSlice.selectors.selectPlan)
  const planPrice = formatAmount(plan?.price?.currency, plan?.price?.unitAmount) || null

  const redirectToSignup = () => {
    window.location.href = getMtUrl('join')
  }
  const [exclusiveSignUpClick] = useEvent([{
    eventName: 'exclusiveSignUpClick',
    onSuccess: redirectToSignup,
    onError: redirectToSignup
  }])

  const handleExclusiveSignupClick = () => {
    exclusiveSignUpClick.trigger({
      contentConsumed,
      meteringLimit
    })
  }

  const PricingMessage = () => {
    const parseUnit = (duration, unit, type) => {
      if (duration === 1 && unit.endsWith('s')) {
        return type === 'trial' ? `${duration} ${unit.slice(0, -1)}` : unit.slice(0, -1)
      }
      return `${duration} ${unit}`
    }

    const planUnit = plan?.intervalUnit && parseUnit(plan.intervalLength, plan.intervalUnit, 'plan')
    const trialLength = plan?.trialLength
    const trialUnit = plan?.trialUnit && parseUnit(plan.trialLength, plan.trialUnit, 'trial')
    // When Trial is set to off, Trial Length is sent as 0
    const shouldDisplayTrialMessage = plan?.hasTrial === true && trialLength > 0

    return (
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        {isMobile
          ? (
            <Typography variant='h5' className={classes.ctaPriceMobile} data-test='paywall-cta-price'>
              <CrownIcon /> Get <strong>Unlimited Access</strong> from <strong>{planPrice}</strong> per/{planUnit} {shouldDisplayTrialMessage && ` - ${trialUnit} FREE trial`}
            </Typography>
            )
          : (
            <>
              <Typography className={classes.ctaPrice} data-test='paywall-cta-price'>
                <CrownIcon /> From {planPrice} per/{planUnit} {shouldDisplayTrialMessage && ` - ${trialUnit} FREE trial`}
              </Typography>
            </>
            )}

      </Box>
    )
  }

  return (
    <Box className={classes.cta} data-test='paywall-cta-container'>
      <Box className={classes.ctaCallout} data-test='paywall-cta-callout'>
        <Typography variant='h4' className={classes.ctaTitle} data-test='paywall-cta-title'>
          Unlock our <strong>premium content</strong> by subscribing today
        </Typography>
        <PricingMessage />
      </Box>
      <Box className={classes.ctaSign} data-test='paywall-cta-sign'>
        <ActionButton
          className={classes.ctaButton}
          size='l'
          variant='grey'
          label='Try for Free'
          onClick={handleExclusiveSignupClick}
          data-test='paywall-cta-sign-up'
        />
        <Typography className={classes.ctaSignIn} variant='body2' data-test='paywall-cta-sign-in'>
          Already a member? <Link className={classes.ctaLink} to='/login'>Sign in now</Link>
        </Typography>
      </Box>
    </Box>
  )
}

export default PaywallCTA
